import { render } from "./AssetQualityDefectList.vue?vue&type=template&id=84b2aad8&scoped=true"
import script from "./AssetQualityDefectList.vue?vue&type=script&lang=js"
export * from "./AssetQualityDefectList.vue?vue&type=script&lang=js"

import "./AssetQualityDefectList.vue?vue&type=style&index=0&id=84b2aad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b2aad8"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QBtn,QTd,QTooltip,QSpinner});
